/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Admins.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ConsentFormAdminApiOutContract,
  ErrorApiOutContract,
  PostConsentformsBody
} from '../pwrdbyQuickMDAdminsApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const postConsentforms = (
    postConsentformsBody: PostConsentformsBody,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(postConsentformsBody.Name !== undefined) {
 formData.append(`Name`, postConsentformsBody.Name)
 }
if(postConsentformsBody.FileName !== undefined) {
 formData.append(`FileName`, postConsentformsBody.FileName)
 }
if(postConsentformsBody['FileStream.CanRead'] !== undefined) {
 formData.append(`FileStream.CanRead`, postConsentformsBody['FileStream.CanRead'].toString())
 }
if(postConsentformsBody['FileStream.CanWrite'] !== undefined) {
 formData.append(`FileStream.CanWrite`, postConsentformsBody['FileStream.CanWrite'].toString())
 }
if(postConsentformsBody['FileStream.CanSeek'] !== undefined) {
 formData.append(`FileStream.CanSeek`, postConsentformsBody['FileStream.CanSeek'].toString())
 }
if(postConsentformsBody['FileStream.CanTimeout'] !== undefined) {
 formData.append(`FileStream.CanTimeout`, postConsentformsBody['FileStream.CanTimeout'].toString())
 }
if(postConsentformsBody['FileStream.Length'] !== undefined) {
 formData.append(`FileStream.Length`, postConsentformsBody['FileStream.Length'].toString())
 }
if(postConsentformsBody['FileStream.Position'] !== undefined) {
 formData.append(`FileStream.Position`, postConsentformsBody['FileStream.Position'].toString())
 }
if(postConsentformsBody['FileStream.ReadTimeout'] !== undefined) {
 formData.append(`FileStream.ReadTimeout`, postConsentformsBody['FileStream.ReadTimeout'].toString())
 }
if(postConsentformsBody['FileStream.WriteTimeout'] !== undefined) {
 formData.append(`FileStream.WriteTimeout`, postConsentformsBody['FileStream.WriteTimeout'].toString())
 }
if(postConsentformsBody.IndividualConsentRequired !== undefined) {
 formData.append(`IndividualConsentRequired`, postConsentformsBody.IndividualConsentRequired.toString())
 }
if(postConsentformsBody.file !== undefined) {
 formData.append(`file`, postConsentformsBody.file)
 }

      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/consentforms`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }
  


export const getPostConsentformsMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConsentforms>>, TError,{data: PostConsentformsBody}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postConsentforms>>, TError,{data: PostConsentformsBody}, TContext> => {

const mutationKey = ['postConsentforms'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postConsentforms>>, {data: PostConsentformsBody}> = (props) => {
          const {data} = props ?? {};

          return  postConsentforms(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostConsentformsMutationResult = NonNullable<Awaited<ReturnType<typeof postConsentforms>>>
    export type PostConsentformsMutationBody = PostConsentformsBody
    export type PostConsentformsMutationError = void | ErrorApiOutContract

    export const usePostConsentforms = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postConsentforms>>, TError,{data: PostConsentformsBody}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postConsentforms>>,
        TError,
        {data: PostConsentformsBody},
        TContext
      > => {

      const mutationOptions = getPostConsentformsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getConsentforms = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<ConsentFormAdminApiOutContract[]>(
      {url: `https://admins-api.api.quick.md/api/v1/consentforms`, method: 'GET', signal
    },
      options);
    }
  



export const getGetConsentformsInfiniteQueryKey = () => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/consentforms`
    ] as const;
    }

export const getGetConsentformsQueryKey = () => {
    return [
    `https://admins-api.api.quick.md/api/v1/consentforms`
    ] as const;
    }

    
export const getGetConsentformsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getConsentforms>>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getConsentforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConsentformsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConsentforms>>> = ({ signal }) => getConsentforms(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getConsentforms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConsentformsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getConsentforms>>>
export type GetConsentformsInfiniteQueryError = void | ErrorApiOutContract


export function useGetConsentformsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getConsentforms>>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getConsentforms>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConsentforms>>,
          TError,
          Awaited<ReturnType<typeof getConsentforms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConsentformsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getConsentforms>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getConsentforms>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConsentforms>>,
          TError,
          Awaited<ReturnType<typeof getConsentforms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConsentformsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getConsentforms>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getConsentforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetConsentformsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getConsentforms>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getConsentforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConsentformsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetConsentformsInfiniteQuery = async <TData = Awaited<ReturnType<typeof getConsentforms>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient,  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getConsentforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetConsentformsInfiniteQueryOptions(options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetConsentformsQueryOptions = <TData = Awaited<ReturnType<typeof getConsentforms>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConsentforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConsentformsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConsentforms>>> = ({ signal }) => getConsentforms(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConsentforms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConsentformsQueryResult = NonNullable<Awaited<ReturnType<typeof getConsentforms>>>
export type GetConsentformsQueryError = void | ErrorApiOutContract


export function useGetConsentforms<TData = Awaited<ReturnType<typeof getConsentforms>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConsentforms>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConsentforms>>,
          TError,
          Awaited<ReturnType<typeof getConsentforms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConsentforms<TData = Awaited<ReturnType<typeof getConsentforms>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConsentforms>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConsentforms>>,
          TError,
          Awaited<ReturnType<typeof getConsentforms>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConsentforms<TData = Awaited<ReturnType<typeof getConsentforms>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConsentforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetConsentforms<TData = Awaited<ReturnType<typeof getConsentforms>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConsentforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConsentformsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetConsentformsQuery = async <TData = Awaited<ReturnType<typeof getConsentforms>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConsentforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetConsentformsQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetConsentformsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getConsentforms>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConsentforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConsentformsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConsentforms>>> = ({ signal }) => getConsentforms(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConsentforms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConsentformsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getConsentforms>>>
export type GetConsentformsSuspenseQueryError = void | ErrorApiOutContract


export function useGetConsentformsSuspense<TData = Awaited<ReturnType<typeof getConsentforms>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConsentforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConsentformsSuspense<TData = Awaited<ReturnType<typeof getConsentforms>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConsentforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConsentformsSuspense<TData = Awaited<ReturnType<typeof getConsentforms>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConsentforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetConsentformsSuspense<TData = Awaited<ReturnType<typeof getConsentforms>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConsentforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConsentformsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetConsentformsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getConsentforms>>>, TError = void | ErrorApiOutContract>( options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getConsentforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConsentformsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConsentforms>>> = ({ signal }) => getConsentforms(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getConsentforms>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConsentformsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getConsentforms>>>
export type GetConsentformsSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetConsentformsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getConsentforms>>>, TError = void | ErrorApiOutContract>(
  options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getConsentforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConsentformsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getConsentforms>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getConsentforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConsentformsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getConsentforms>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getConsentforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetConsentformsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getConsentforms>>>, TError = void | ErrorApiOutContract>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getConsentforms>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConsentformsSuspenseInfiniteQueryOptions(options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




